import {AfterViewInit, Component, EventEmitter, OnInit, Output, ViewChild} from '@angular/core';
import {MyDialogDataModel} from '../../models/my-dialog-data.model';
import {ProjectListItemFilterModel} from '../../models/project-list-item-filter.model';
import {LocalStorageService} from '../../../../core/services/local-storage.service';
import {ModalDialogV3} from '../../../../shared-modal-dynamic/models/modal-dialog-v3';
import {LabeledClearableInputComponent} from '../../../../shared/components/labeled-clearable-input/labeled-clearable-input.component';

@Component({
    selector: 'app-projects-filter-modal',
    templateUrl: './projects-filter-modal.component.html',
    styleUrls: ['./projects-filter-modal.component.scss']
})
export class ProjectsFilterModalComponent extends ModalDialogV3 implements OnInit,AfterViewInit  {


    @Output() public closeFilterModal = new EventEmitter<boolean>();

    public dialogModel: MyDialogDataModel;
    public projectListItemFilter = new ProjectListItemFilterModel();

    @ViewChild('projectNameInput') projectNameInput: LabeledClearableInputComponent;


    constructor(private localStorageService: LocalStorageService
    ) {
        super();
    }


    public resetFilter() {
        this.projectListItemFilter = new ProjectListItemFilterModel();
        // this.filterLocalStorageService.removeItem('projectFilter');  // will be saved after dialog will be confirmed
    }


    public closeModal() {
        // this.filterLocalStorageService.setItem('projectFilter', JSON.stringify(this.projectListItemFilter));
        this.close();
    }

    public ngOnInit() {

        try {
            this.projectListItemFilter = ProjectListItemFilterModel.fromJson(JSON.parse(this.localStorageService.getProjectFilter())) as ProjectListItemFilterModel;
        } catch (e) {
            console.error('ProjectsFilterModalComponent: ' + e);
            this.projectListItemFilter = {};
        }

        if (this.projectListItemFilter === undefined || this.projectListItemFilter === null) {
            this.resetFilter();

        }
    }


    public hasFilterValues(): boolean {
        return this.projectListItemFilter && !!(Object.keys(this.projectListItemFilter).some(key => key !== 'status' && this.projectListItemFilter[key]));
    }

    public setFilter() {
        this.localStorageService.saveProjectFilter(ProjectListItemFilterModel.stringify(this.projectListItemFilter));
        this.announceModelChanged();
        this.close();
    }

    ngAfterViewInit() {
        this.projectNameInput.inputRef?.nativeElement.focus();
    }

}
